import React, { useState } from 'react';
import type { FormField, ThemeConfig } from '../../../types/forms';
import { getInputStyles } from '../../../lib/themeUtils';
import { useScrollIntoViewOnFocus } from '../../../hooks/useScrollIntoViewOnFocus';

interface TextAreaFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  field,
  value = '',
  onChange,
  error,
  disabled,
  themeConfig,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputStyles = getInputStyles(themeConfig, { error: !!error, focused: isFocused });
  const scrollOnFocus = useScrollIntoViewOnFocus<HTMLTextAreaElement>();

  return (
    <textarea
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onFocus={(e) => { setIsFocused(true); scrollOnFocus(e); }}
      onBlur={() => setIsFocused(false)}
      placeholder={field.placeholder || ''}
      required={field.required}
      disabled={disabled}
      minLength={field.validation?.minLength}
      maxLength={field.validation?.maxLength}
      rows={4}
      /* mobile-ui.6.E E2: no short (landscape phone) o campo encolhe pra ~2 linhas (72px:
         24px padding + 2×24px line-height) — decisão PO mesmo sendo texto longo; a classe
         de height vence o rows=4 e o campo cabe INTEIRO entre header e footer em 667×375.
         Scroll interno do textarea segue (overflow nativo). Portrait/desktop: rows=4 intacto. */
      className="w-full min-w-0 max-w-full px-4 py-3 short:h-18 focus:outline-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed resize-none"
      style={inputStyles}
    />
  );
};
